import {
  GAME_INFO,
  toAnalysisPost,
  toGameStartPage,
  toGameSubPage,
} from '../main/actions/router';
import { getGameType } from './productUtil';

export function createAnalysisArticleAction(article, shouldLinkMatch) {
  const { slug, round, matches } = article;

  if (shouldLinkMatch) {
    const matchSlug =
      matches && matches.length > 0 ? matches[0].slug : undefined;
    const { type: roundType, id: roundId } = round || {};

    const actionCreator =
      matchSlug != null ? toGameSubPage.bind(null, GAME_INFO) : toGameStartPage;

    const gameType =
      roundType != null && roundId != null ? roundType : undefined;

    if (matchSlug != null || gameType === roundType) {
      return actionCreator({
        gameType: getGameType(gameType),
        roundId,
        slug: matchSlug,
      });
    }
  }
  // // Default to ANALYSIS_POST
  return toAnalysisPost({ slug });
}

const EMPTY_ISH_P_TAG = '<p>.</p>';

export const getText = (article, preferTeaser = true) =>
  preferTeaser && article.teaser != null
    ? article.teaser
    : article.text == null ||
      article.text.replace(/\s/g, '').length <= EMPTY_ISH_P_TAG.length
    ? undefined
    : article.text;

export const getHeadline = (article, preferTeaser = true) =>
  preferTeaser && article.teaser_headline != null
    ? article.teaser_headline
    : article.headline;
